import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import CarouselItem from "../Carousel.interface"

import "./Boxes.css";



export default class BoxesCarouselItem extends Component {

    props: any;

    state: CarouselItem;



    constructor(props) {
        super(props);

        this.state = {
            index: this.props.carouselItem.index,
            title: this.props.carouselItem.title,
            richDescription: this.props.carouselItem.richDescription,
            content: this.props.carouselItem.content,
            url: this.props.carouselItem.url,
            link: this.props.carouselItem.link,
            icon: this.props.carouselItem.icon,
            image: null,
            mobileImage: null,
            createDate:null
        };
    }

    render() {
       
        return (            
            <div className="item mst-carousel-item d-flex overflow-hidden h-100" >

                <div className="mst-card mst-box-item d-flex flex-column align-items-center  justify-content-center mx-auto" >

                    <div className="text-center">
                        <div className="mb-4">
                            
                            <i className={(this.state.icon) + ' minisite-font-36 pallete-color'}></i>
                        </div>
                       


                        <div className="mst-card-content px-2 px-md-3 px-lg-3 content-txt">

                            <h3 className="content-large-txt regular-txt mb-4">{this.state.title}</h3>
                            <div className=" mx-auto hr"></div>

                           

                            

                        </div>                       
                    </div>
                    <div className="align-bottom " >

                        <CustomLinkButton
                            title={this.state.title}
                            pageUrl={this.state.url}
                            link={this.state.link}
                            isBtn={false}
                            btnClass={"btn btn-outline-primary mst-btn mst-btn-round px-auto"}
                            linkClass={""}
                            dir={this.props.dir}
                            linkIcon={true}/>

                    </div>
                </div>

            </div>




        );
    }
}
